<template>
  <div>
    <wc-data-box
      :mini='mini'
      :title='dataBox.title'
      :titleIcon='dataBox.icon'
      :titleIconColor='dataBox.iconColor'
      :loading='isLoading'
      showHelp
      helpText="These should act like a yellow Post-It Notes. Add a sticky to the system for anything that needs to be dealt with.<br><br> Note that invoices will NOT be able to be sent if there are any stickies on the project/estimate."
      showAdd
      @add='addNew'
    >
      <v-card flat v-if='stickies.length === 0'>
        <v-card-text>
          {{ isLoading ? "Loading..." : "None found." }}
        </v-card-text>
      </v-card>
      <template v-for='(sticky, index) in sortedStickies'>
        <v-divider v-if='index > 0' :key='sticky.id'></v-divider>
        <v-card flat :key="index + '-' + sticky.id" @click='edit(sticky)'>
          <v-card-subtitle class='pb-2 d-flex align-baseline'>
            <wc-avatar :profile='sticky.created_by_obj'></wc-avatar>
            <span class='mx-2 heading-6'>{{ sticky.date_created | shortDate }}</span>
            <small v-if='sticky.time'>{{ sticky.time | time }}</small>
          </v-card-subtitle>
          <v-card-text>
            <span class='black--text'>{{ sticky.description }}</span>
          </v-card-text>
        </v-card>
      </template>


    </wc-data-box>

    <wc-dialog
      :title='dataBox.title'
      :icon='dataBox.icon'
      :iconColor='dataBox.iconColor'
      :showDialog='showDialog'
      :loadingButtons='isLoading'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-form v-model='isFormValid'>
        <v-textarea
          outlined
          label='Sticky'
          v-model='stickyCopy.description'
        ></v-textarea>
<!--         <v-checkbox
          label='Is this time sensitive?'
          v-model='stickyCopy.is_time_sensitive'
        ></v-checkbox>
        <v-checkbox
          label='Make highlighted?'
          v-model='stickyCopy.is_highlighted'
        ></v-checkbox> -->
      </v-form>
      <template v-slot:dialog-actions v-if='stickyCopy.id'>
        <v-btn depressed small color='error' @click='showConfirm = true'>Delete</v-btn>
      </template>
    </wc-dialog>

    <wc-confirm :showDialog='showConfirm' :loading='isLoading' @confirm='deleteSticky' @cancel='showConfirm = false'>
      Are you sure you want to delete this sticky? This cannot be undone!
    </wc-confirm>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import miscServices from '@/services/misc'
import formRules from '@/mixins/formRules'
import projectsAPI from '../api/projects'
import estimatesAPI from '@/modules/estimates/api/estimates'
import WCAvatar from '@/components/misc/WCAvatar'

export default {
  name: 'stickies',
  mixins: [formRules],
  props: {
    project: {
      required: false
    },
    estimate: {
      required: false
    },
    mini: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    showConfirm: false,
    title: 'Stickies',
    icon: 'mdi-note',
    iconColor: 'yellow darken-1',
    stickies: [],
    stickyCopy: {},
    showDialog: false
  }),
  computed: {
    dataBox () {
      return this.$store.state.icons.dataBox.stickies
    },
    sortedStickies () {
      // return _.orderBy(this.stickies, ['date_created', 'time'], ['desc', 'desc'])
      // re-instate sort by time if/when we add that field to the sticky
      return _.orderBy(this.stickies, ['date_created', 'id'], ['desc', 'desc'])
    }
  },
  mounted () {
    this.getData()
  },
  watch: {
    'project.id'() {
      if (this.project && this.project.id) {
        this.getData()
      }
    },
    'estimate.id'() {
      if (this.estimate && this.estimate.id) {
        this.getData()
      }
    }
  },
  methods: {
    stickyCopyReset () {
      this.stickyCopy.id = null
      this.stickyCopy.created_by = this.$store.state.auth.profile.id
      this.stickyCopy.date_created = moment().format('YYYY-MM-DD')
      this.stickyCopy.is_time_sensitive = false
      this.stickyCopy.is_highlighted = false
      this.stickyCopy.description = ''
      if (this.project) {
        this.stickyCopy.project = this.project.id
        this.stickyCopy.estimate = null
      } else if (this.estimate) {
        this.stickyCopy.project = null
        this.stickyCopy.estimate = this.estimate.id
      } else {
        // this step should never happen - MJ
        this.stickyCopy.project = null
        this.stickyCopy.estimate = null
      }
    },
    async getData () {
      this.isLoading = true
      if (this.project) {
        this.stickies = await projectsAPI.getProjectStickies(this.project.id)
      } else if (this.estimate) {
        this.stickies = await estimatesAPI.getEstimateStickies(this.estimate.id)
      }
      this.isLoading = false
    },
    async deleteSticky () {
      this.isLoading = true
      if (this.stickyCopy.project) {
        await projectsAPI.removeProjectSticky(this.stickyCopy)
      } else if (this.stickyCopy.estimate) {
        await estimatesAPI.removeEstimateSticky(this.stickyCopy)
      }
      this.stickies = miscServices.removeObject(this.stickies, this.stickyCopy)
      this.isLoading = false
      this.showDialog = false
      this.showConfirm = false
    },
    edit (item) {
      this.stickyCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    addNew () {
      this.stickyCopyReset()
      this.showDialog = true
    },
    async saveChanges () {
      this.isLoading = true
      let tmp
      if (this.stickyCopy.id) {
        if (this.stickyCopy.project) {
          tmp = await projectsAPI.updateProjectSticky(this.stickyCopy)
        } else if ( this.stickyCopy.estimate) {
          tmp = await estimatesAPI.updateEstimateSticky(this.stickyCopy)
        }
        this.stickies = miscServices.replaceObject(this.stickies, tmp)
      } else {
        if (this.stickyCopy.project) {
          tmp = await projectsAPI.addProjectSticky(this.stickyCopy)
        } else if ( this.stickyCopy.estimate) {
          tmp = await estimatesAPI.addEstimateSticky(this.stickyCopy)
        }
        this.stickies.push(tmp)
      }
      this.showDialog = false
      this.isLoading = false
    }
  },
  components: {
    'wc-avatar': WCAvatar
  }
}
</script>
